import { render } from "./WorkspaceCard.vue?vue&type=template&id=7aa1fb18"
import script from "./WorkspaceCard.vue?vue&type=script&lang=js"
export * from "./WorkspaceCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__